/**
 * @file index.ts
 * @description i18n exports for TournamentJoinPayment components (Task 30.3)
 */

import { recoveryTranslations as enRecovery, tournamentJoinPaymentTranslations as enJoinPayment } from './en';

export const translations = {
  en: {
    recovery: enRecovery,
    joinPayment: enJoinPayment,
  },
};

export type SupportedLocale = keyof typeof translations;

/**
 * Get recovery translations for a given locale
 */
export const getRecoveryTranslations = (locale: SupportedLocale = 'en') => {
  return translations[locale]?.recovery || translations.en.recovery;
};

/**
 * Get join payment translations for a given locale
 */
export const getJoinPaymentTranslations = (locale: SupportedLocale = 'en') => {
  return translations[locale]?.joinPayment || translations.en.joinPayment;
};

/**
 * Simple template string interpolation
 * Usage: interpolate('Hello {name}!', { name: 'World' }) => 'Hello World!'
 */
export const interpolate = (
  template: string,
  values: Record<string, string | number>
): string => {
  return template.replace(/{(\w+)}/g, (_, key) => String(values[key] ?? `{${key}}`));
};

// Re-export types from en.ts
export type { RecoveryTranslations, TournamentJoinPaymentTranslations } from './en';
